export default [
  {
    type: 'gif',
    url: 'https://i.giphy.com/Pn1gZzAY38kbm.gif',
  },
  {
    type: 'gif',
    url: 'https://i.giphy.com/mlvseq9yvZhba.gif',
  },
  {
    type: 'gif',
    url: 'https://i.giphy.com/BCgcfnaGDaYai5eYD1.gif',
  },
  {
    type: 'image',
    url: 'https://static.buffer.com/images/engage/mocks/mocked-attachment-01.jpg',
  },
  {
    type: 'image',
    url: 'https://static.buffer.com/images/engage/mocks/mocked-attachment-02.png',
  },
  {
    type: 'image',
    url: 'https://static.buffer.com/images/engage/mocks/mocked-attachment-03.png',
  },
  {
    type: 'image',
    url: 'https://static.buffer.com/images/engage/mocks/mocked-attachment-04.jpg',
  },
  {
    type: 'image',
    url: 'https://static.buffer.com/images/engage/mocks/mocked-attachment-05.png',
  },
  {
    type: 'image',
    url: 'https://static.buffer.com/images/engage/mocks/mocked-attachment-06.png',
  },
]
